import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-forbidden',
  templateUrl: './page-forbidden.component.html'  
})
export class PageForbiddenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
